// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vconsole from "vconsole";
import "mint-ui/lib/style.css";
import weixin_jssdk_ops from "./common/wx/wechart.1";
import "./assets/main.css";
import VuePureLightbox from "vue-pure-lightbox";
import styles from "vue-pure-lightbox/dist/VuePureLightbox.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

function refreshRem() {
    let designSize = 1920; // 设计图尺寸
    let html = document.documentElement;
    console.log("适配");
    let wW = html.clientWidth; // 窗口宽度;
    if (wW < 1200) {
        wW = 1200; // 窗口宽度
    }
    let rem = (wW * 100) / designSize;
    document.documentElement.style.fontSize = rem + "px";
}
var tid;
window.addEventListener(
    "resize",
    function () {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    },
    false
);
refreshRem();
Vue.use(ElementUI);

// weixin_jssdk_ops.init({
//   title: 'CRM 心·动·赢 ',
//   description: 'Pacing to Win',
//   img: 'https://incker.oss-cn-shanghai.aliyuncs.com/share-icon.png?v=2'
// });

Vue.config.productionTip = false;
// Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js